import {
  ServerResolutionResult,
  StringResolutionType,
} from 'notebook/tables/string-resolution/StringResolutionConstants';
import {TypedValue} from 'notebook/tables/typed-values/TypedValueConstants';

/**
 * Helper function to create a server resolution result for a custom string resolution query with no error.
 * @param typedValue - typed value to wrap
 */
export default function makeCustomResolutionResultFromTypedValue(
  typedValue: TypedValue | null,
  error?: string,
  isWarning?: boolean
): ServerResolutionResult {
  return {
    type: StringResolutionType.CUSTOM,
    error,
    isWarning,
    resolvedValue: {
      typedValue,
    },
  };
}
